<template>
  <q-dialog :model-value="modelValue" position="right" full-height @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width:640px; max-width:92vw">
      <q-bar class="bg-primary text-white">
        <q-icon name="work" size="18px" />
        <span class="q-ml-sm text-caption ellipsis" style="max-width:480px">{{ data.workName }}</span>
        <q-space />
        <q-btn icon="close" flat dense no-caps size="md" label="Закрыть" v-close-popup />
      </q-bar>

      <div v-if="data.loading" class="q-pa-lg text-center">
        <q-spinner size="30px" color="primary" />
      </div>

      <q-scroll-area v-else style="height: calc(100vh - 50px)">
        <div v-if="data.workGuid" class="q-px-sm q-pt-sm">
          <div class="text-caption text-grey-6">гуид: <span class="text-grey-8">{{ data.workGuid }}</span></div>
        </div>

        <div class="q-pa-sm q-mt-sm text-subtitle2" style="color:#b45309">работа</div>
        <q-markup-table dense flat separator="cell" class="q-mb-md">
          <thead>
            <tr style="background:#fff3e0">
              <th class="text-left">дата факта</th>
              <th class="text-right">объём факт</th>
              <th class="text-right">цена</th>
              <th class="text-right">сумма</th>
              <th class="text-center">статус</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in data.facts" :key="f.value_date">
              <td class="text-left text-caption">{{ fmtDateRu(f.value_date) }}</td>
              <td class="text-right mono">{{ fmtNum(f.fact_value) }}</td>
              <td class="text-right mono">{{ fmtNum(f.work_set_price) }}</td>
              <td class="text-right mono">{{ fmtNum(f.fact_price) }}</td>
              <td class="text-center">
                <span :class="f.is_sent ? 'text-green-7' : 'text-orange-7'" class="text-caption text-weight-medium">
                  {{ f.is_sent ? 'отправлен' : 'не отправлен' }}
                </span>
              </td>
            </tr>
            <tr v-if="!data.facts.length">
              <td colspan="5" class="text-center text-grey-5">Нет данных</td>
            </tr>
          </tbody>
        </q-markup-table>

        <template v-for="(group, gi) in materialGroups" :key="gi">
          <div class="q-pa-sm text-subtitle2" style="color:#1565c0">{{ group.name }}<span v-if="group.unit" class="text-caption text-grey-6">/{{ group.unit }}</span></div>
          <q-markup-table dense flat separator="cell" class="q-mb-md">
            <thead>
              <tr style="background:#e3f2fd">
                <th class="text-left">дата факта</th>
                <th class="text-right">кол-во</th>
                <th class="text-right">цена</th>
                <th class="text-right">сумма</th>
                <th class="text-center">статус</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="m in group.rows" :key="m.value_date">
                <td class="text-left text-caption">{{ fmtDateRu(m.value_date) }}</td>
                <td class="text-right mono">{{ fmtNum(m.fact_value) }}</td>
                <td class="text-right mono">{{ fmtNum(m.work_set_price) }}</td>
                <td class="text-right mono">{{ fmtNum(m.fact_price) }}</td>
                <td class="text-center">
                  <span :class="m.is_sent ? 'text-green-7' : 'text-orange-7'" class="text-caption text-weight-medium">
                    {{ m.is_sent ? 'отправлен' : 'не отправлен' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </q-markup-table>
        </template>
        <div v-if="!materialGroups.length && data.facts.length" class="q-pa-sm text-grey-5 text-caption">
          Материалы отсутствуют
        </div>
      </q-scroll-area>
    </q-card>
  </q-dialog>
</template>

<script>
import { useFormatters } from '../composables/useFormatters';

export default {
  name: 'PpmUspWorkDetailDialog',
  props: {
    modelValue: Boolean,
    data: { type: Object, default: () => ({ show: false, loading: false, workName: '', workGuid: '', facts: [], materials: [] }) },
  },
  emits: ['update:modelValue'],
  setup() {
    const { fmtNum, fmtDateRu } = useFormatters();
    return { fmtNum, fmtDateRu };
  },
  computed: {
    materialGroups() {
      const mats = this.data.materials || [];
      const map = new Map();
      for (const m of mats) {
        const key = m.material_name || '—';
        if (!map.has(key)) map.set(key, { name: key, unit: m.unit_name || '', rows: [] });
        map.get(key).rows.push(m);
      }
      return [...map.values()];
    },
  },
};
</script>
